import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext({ content: null, reload: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const reload = useCallback(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => setContent(null));
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <ContentContext.Provider value={{ content, reload }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
